/**
 * @class dhsAPI
 * @brief The DHS Program Indicator Data API Library
 * @details JavaScript library for utilizing the DHS API.
 * @version 0.1
 * @date 06/20/2014
 */
var dhsAPI = (function() {
  //Private Defines
  /**
   * @struct FILTERS
   * @property countryIds <OPTIONAL> Comma delimited list of country codes. Can be null or empty.
   * @property countryIdType <OPTIONAL> String specifying the country code type listed under lstCountryIds. Can be null or empty.
   * @property indicatorIds <OPTIONAL> Comma delimited list of indicator IDs. Can be null or empty.
   * @property surveyIds <OPTIONAL> Comma delimited list of survey IDs. Can be null or empty.
   * @property surveyYear <OPTIONAL> Integer specifying a particular Survey year.
   * @property surveyType <OPTIONAL> String specifying the Survey type. Can be null or empty.
   * @property format <OPTIONAL> String specifying the format to return the data in. json, pjson, jsonp, html. Default is JSON.
   * @property perpage <OPTIONAL> Integer specifying the maximum number of records that can be returned. If not speciied, default is 100.
   * @property page <OPTIONAL> Integer specifying the page number. If not specified, default is 1.
   * @property apiKey <OPTIONAL> String representing your API Key. Can be null or empty.
   * @property returnFields <OPTIONAL> Comma delimited list of columns that should be returned. Can be null or empty.
   */

  //Private Variables.
  /**
   */

  var API_URL = window.DHS_API_ENDPOINT;

  /**
   */
  var INTERFACE_TYPE = {
    Countries: 'countries',
    Data: 'data',
    Indicators: 'indicators',
    Info: 'info',
    Surveys: 'surveys',
    Tags: 'tags',
  };

  /**
   */
  var _APIKEY_PARAM = 'apiKey=DHSPRG-949817';

  // 	var _PERPAGE_INTEGER = 30000;
  var _PERPAGE_INTEGER = 4000;
  /**
   */
  var _PERPAGE_PARAM = 'perpage=' + _PERPAGE_INTEGER;

  /**
   */
  var _LANG_PARAM = 'lang=';

  /**
   */
  var DEFAULT_CALLBACK_MSG = 'Loading 0 of ' + _PERPAGE_INTEGER + ' records...';

  /**
   * @fn _getDataFromAPI
   * @brief Returns the data or a promise object used to retreive the data when the request completes.
   * @details This function is responsible for querying the API and can use Asynchronous or Synchronous calls.
   * @return (Asynchronous) Returns a jQuery deffered object. Please utilize the object's done method to obtain the data.
   * 		  (Synchronous) Returns the actual result in json format/object.
   * @version 0.1
   * @date 06/20/2014
   */
  var _getDataFromAPI = function(interfaceType, objFilter, UseAsync) {
    //Declare Important Variables.
    var strURL = API_URL + interfaceType;
    var strFilters = '';
    var objExternalDeferred; //The deferred object return to the user.
    var bIsAsync = true; //Determine Sync/Async call.
    var objSyncResult; //Final data result to return to the user (Synchronous Call).

    //////////////////////////////////////////////
    //  DETERMINE SYNC/ASYNC CALL.
    //////////////////////////////////////////////

    //Check whether the call has been specified as sync or async.
    if (typeof UseAsync != 'undefined') {
      bIsAsync = UseAsync;
    }

    //////////////////////////////////////////////
    //  SETUP URL
    //////////////////////////////////////////////

    //Check on all the filters and add ones that are available.
    var strFilters = '';
    for (var curFilter in objFilter) {
      if (objFilter.hasOwnProperty(curFilter)) {
        strFilters = _addQueryParams(
          strFilters,
          curFilter + '=' + objFilter[curFilter]
        );
      }
    }

    //Add the PerPage Parameter.
    strFilters = _addQueryParams(strFilters, _PERPAGE_PARAM);

    //Add the API Key Parameter.
    strFilters = _addQueryParams(strFilters, _APIKEY_PARAM);

    //Construct the URL to call to obtain data.
    if (interfaceType == INTERFACE_TYPE.Data) {
      strURL += '/all' + strFilters;
    } else {
      strURL += strFilters;
    }

    //////////////////////////////////////////////
    //  ASYNCHRONOUS CALL
    //////////////////////////////////////////////

    if (bIsAsync) {
      //ASYNCHRONOUS
      //Create a new promise object.
      objExternalDeferred = $.Deferred();

      //Make an initial ajax call to retreive the data.
      $.ajax({
        async: true,
        type: 'GET',
        url: strURL,

        dataType: 'json',
        success: function(data) {
          objExternalDeferred.resolve(data);
        },
        error: function(errMsg) {
          objExternalDeferred.reject(errMsg.statusText);
        },
      });

      //Return the Deferred Object.
      return objExternalDeferred;
    }

    //////////////////////////////////////////////
    //  SYNCHRONOUS CALL
    //////////////////////////////////////////////
    else {
      //SYNCHRONOUS
      //Make an ajax call to retreive the data.
      $.ajax({
        async: false,
        type: 'GET',
        url: strURL,
        //data: { get_param: 'value' },
        dataType: 'json',
        success: function(data) {
          objSyncResult = data;
        },
        error: function(errMsg) {
          objSyncResult = errMsg.statusText;
        },
      });

      //Return the Actual Result.
      return objSyncResult;
    }
  };

  /**
   * @fn _getDataFromAPI2
   * @brief Returns the data or a promise object used to retreive the data when the request completes. MULTI PAGE.
   * @details This function is responsible for querying the API and can use Asynchronous or Synchronous calls.
   * @return (Asynchronous) Returns a jQuery deffered object. Please utilize the object's done method to obtain the data.
   * 		  (Synchronous) Returns the actual result in json format/object.
   * @version 0.1
   * @date 06/20/2014
   */
  var _getDataFromAPI2 = function(
    interfaceType,
    objFilter,
    UseAsync,
    showCallback,
    hideCallback,
    originalData
  ) {
    //Declare Important Variables.
    var strURL = API_URL + interfaceType;
    var strFilters = '';
    var objArrayInternalDeferred = []; //Array of internal deferred objects if required for pagination.
    var objExternalDeferred; //The deferred object return to the user.
    var bIsAsync = true; //Determine Sync/Async call.
    var objResult; //Final data result to return to the user
    var bUseCallback = false;
    var nRecordsObtained = 0;
    var nRecordsIncrement = _PERPAGE_INTEGER;
    var nTotalRecords = _PERPAGE_INTEGER;

    //////////////////////////////////////////////
    //  DETERMINE WHETHER TO USE CALLBACK
    //////////////////////////////////////////////
    if (showCallback && hideCallback) {
      bUseCallback = true;
    }

    //////////////////////////////////////////////
    //  DETERMINE SYNC/ASYNC CALL.
    //////////////////////////////////////////////

    //Check whether the call has been specified as sync or async.
    if (typeof UseAsync != 'undefined') {
      bIsAsync = UseAsync;
    }

    //////////////////////////////////////////////
    //  SETUP URL
    //////////////////////////////////////////////

    //Check on all the filters and add ones that are available.
    var strFilters = '';
    for (var curFilter in objFilter) {
      if (objFilter.hasOwnProperty(curFilter)) {
        strFilters = _addQueryParams(
          strFilters,
          curFilter + '=' + objFilter[curFilter]
        );
      }
    }

    //Add the PerPage Parameter.
    strFilters = _addQueryParams(strFilters, _PERPAGE_PARAM);

    //Add the API Key Parameter.
    strFilters = _addQueryParams(strFilters, _APIKEY_PARAM);

    //Add the language Parameter.
    strFilters = _addQueryParams(
      strFilters,
      _LANG_PARAM + Config.getLanguage()
    );

    //Construct the URL to call to obtain data.
    if (interfaceType == INTERFACE_TYPE.Data) {
      strURL += '/all' + strFilters;
    } else {
      strURL += strFilters;
    }
    var queryLength = strURL.length - API_URL.length;
    if (queryLength > 2000) {
      alert(
        'An Error has Occurred \r\n\r\n The number of items selected has resulted in an URL that is too long for the server to handle. Please select fewer items.'
      );
      window.location.search = '';
      return false;
    }
    //////////////////////////////////////////////
    //  INITIALIZE CALLBACK.
    //////////////////////////////////////////////
    if (bUseCallback) {
      showCallback(Config.getUniversalString('loading'));
    }

    //////////////////////////////////////////////
    //  ASYNCHRONOUS CALL
    //////////////////////////////////////////////

    if (bIsAsync) {
      //ASYNCHRONOUS
      //Create a new External Deferred Object.
      objExternalDeferred = $.Deferred();

      //Make an initial ajax call to retreive the data.
      $.ajax({
        async: true,
        type: 'GET',
        url: strURL,
        dataType: 'json',
        success: function(data) {
          //Assign data.
          if (typeof originalData != 'undefined') {
            //Set new data.
            objResult = data;

            //Append Original data.
            objResult.Data.push.apply(objResult.Data, originalData);
          } else {
            //Set new data.
            objResult = data;
          }

          //Obtain Total Number of Pages.
          var nTotalPages = objResult.TotalPages;

          //Check if there is more data to be obtained through pagination.
          if (nTotalPages > 1) {
            //Update Callback.
            if (bUseCallback) {
              //Increment records obtained.
              nRecordsObtained += nRecordsIncrement;

              //Get Total Records.
              nTotalRecords = objResult.RecordCount;

              _executeCallBack(showCallback, nRecordsObtained, nTotalRecords);
            }

            var allRequestsMade = function(objArrayInternalDeferred) {
              $.when
                .apply($, objArrayInternalDeferred)
                .done(function() {
                  //Update Callback.
                  if (bUseCallback) {
                    //Increment records obtained.
                    nRecordsObtained += nTotalRecords;

                    _executeCallBack(
                      showCallback,
                      nRecordsObtained,
                      nTotalRecords
                    );
                  }

                  //Set Promise Object.
                  objExternalDeferred.resolve(objResult);

                  //Execute Hide Callback.
                  if (bUseCallback) {
                    hideCallback();
                  }
                })
                .fail(function(errMsg) {
                  //Abort every deferred object that is still running.
                  $.each(objArrayInternalDeferred, function(index, objDef) {
                    if (objDef.state() === 'pending') {
                      objDef.abort();
                    }
                  });
                });
            };

            //Create a deferred object for each additional page.
            //for(var nIndex = 2; nIndex <= nTotalPages; nIndex++) {
            var nIndex = 2;
            var strCurURL = strURL;
            var strCurURL = _addQueryParams(strCurURL, 'page=' + nIndex);

            var requestPage = function(nIndex, strCurURL) {
              var objTempDeferred = $.ajax({
                async: true,
                type: 'GET',
                url: strCurURL,
                dataType: 'json',
                success: function(data, evt, val) {
                  //Update Callback.
                  if (bUseCallback) {
                    //Increment records obtained.
                    nRecordsObtained += nRecordsIncrement;

                    //Execute Callback
                    _executeCallBack(
                      showCallback,
                      nRecordsObtained,
                      nTotalRecords
                    );
                  }

                  //Append data.
                  objResult.Data.push.apply(objResult.Data, data.Data);

                  var nNextIndex = nIndex + 1;

                  if (nNextIndex <= nTotalPages) {
                    requestPage(
                      nNextIndex,
                      _addQueryParams(strURL, 'page=' + nNextIndex)
                    );
                  } else {
                    allRequestsMade(objArrayInternalDeferred);
                  }
                },
                error: function(errMsg) {
                  console.log('Error');
                },
              });
              objArrayInternalDeferred.push(objTempDeferred);
            };

            requestPage(nIndex, strCurURL);
          } else {
            objExternalDeferred.resolve(objResult);

            //Execute Hide Callback.
            if (bUseCallback) {
              hideCallback();
            }
          }
        },
        error: function(errMsg) {
          objExternalDeferred.reject(errMsg.statusText);
        },
      });

      //Return the Deferred Object.
      return objExternalDeferred;
    }

    //////////////////////////////////////////////
    //  SYNCHRONOUS CALL
    //////////////////////////////////////////////
    else {
      //SYNCHRONOUS
      //Make an ajax call to retreive the data.
      $.ajax({
        async: false,
        type: 'GET',
        url: strURL,
        //data: { get_param: 'value' },
        dataType: 'json',
        success: function(data) {
          objResult = data;
        },
        error: function(errMsg) {
          objResult = errMsg.statusText;
        },
      });

      //Return the Actual Result.
      return objResult;
    }
  };
  /**
   */
  var _addQueryParams = function(strSourceParams, strNewParam) {
    //If the string is empty, then add with an "?" in front.
    if (strSourceParams.length == 0) {
      strSourceParams = '?' + strNewParam;
    } else {
      //Add additional Parameters with &
      strSourceParams += '&' + strNewParam;
    }

    //Return the Parameters string with the new parameter added.
    return strSourceParams;
  };
  /**
   */
  var _executeCallBack = function(
    callbackMethod,
    currentRecords,
    totalRecords
  ) {
    var cRecords = currentRecords
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var tRecords = totalRecords
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    callbackMethod(
      Config.getUniversalString('loaded') +
        ' ' +
        cRecords +
        '/' +
        tRecords +
        ' ' +
        Config.getUniversalString('records') +
        '...'
    );
  };

  var onlyUnique = function(value, index, self) {
    return self.indexOf(value) === index;
  };

  return {
    /**
     * @fn getCountries
     * @brief Returns the Countrys requested with their specific details.
     * @details Provides results in an object specified by the FILTERS.format field. Default is JSON.
     * @param   FILTERS:
     * @param   UseAsync:
     * @return  (Asynchronous) Returns a jQuery deffered object. Please utilize the object's done method to obtain the data.
     * 		   (Synchronous) Returns the actual result in json format/object.
     * @version 0.1
     * @date 06/20/2014
     */
    getCountries: function(
      FILTERS,
      UseAsync,
      showCallback,
      hideCallback,
      originalData
    ) {
      return _getDataFromAPI2(
        INTERFACE_TYPE.Countries,
        FILTERS,
        UseAsync,
        showCallback,
        hideCallback,
        originalData
      );
    },
    /**
     * @fn getIndicators
     * @brief Returns the Indicators requested with their specific details.
     * @details Provides results in an object specified by the FILTERS.format field. Default is JSON.
     * @return (Asynchronous) Returns a jQuery deffered object. Please utilize the object's done method to obtain the data.
     * 		  (Synchronous) Returns the actual result in json format/object.
     * @version 0.1
     * @date 06/20/2014
     */
    getIndicators: function(
      FILTERS,
      UseAsync,
      showCallback,
      hideCallback,
      originalData
    ) {
      return _getDataFromAPI2(
        INTERFACE_TYPE.Indicators,
        FILTERS,
        UseAsync,
        showCallback,
        hideCallback,
        originalData
      );
    },
    /**
     * @fn getSurveys
     * @brief Returns the Surveys requested with their specific details.
     * @details Provides results in an object specified by the FILTERS.format field. Default is JSON.
     * @return (Asynchronous) Returns a jQuery deffered object. Please utilize the object's done method to obtain the data.
     * 		  (Synchronous) Returns the actual result in json format/object.
     * @version 0.1
     * @date 06/20/2014
     */
    getSurveys: function(
      FILTERS,
      UseAsync,
      showCallback,
      hideCallback,
      originalData
    ) {
      return _getDataFromAPI2(
        INTERFACE_TYPE.Surveys,
        FILTERS,
        UseAsync,
        showCallback,
        hideCallback,
        originalData
      );
    },
    /**
     * @fn getData
     * @brief Returns the Data requested with their specific details.
     * @details Provides results in an object specified by the FILTERS.format field. Default is JSON.
     * @return (Asynchronous) Returns a jQuery deffered object. Please utilize the object's done method to obtain the data.
     * 		  (Synchronous) Returns the actual result in json format/object.
     * @version 0.1
     * @date 06/20/2014
     */
    getData: function(
      FILTERS,
      UseAsync,
      showCallback,
      hideCallback,
      originalData
    ) {
      //check that request is only looking for unique indicators
      var indicatorIds = FILTERS.indicatorIds.split(',');
      FILTERS.indicatorIds = indicatorIds.filter(onlyUnique).join(',');
      return _getDataFromAPI2(
        INTERFACE_TYPE.Data,
        FILTERS,
        UseAsync,
        showCallback,
        hideCallback,
        originalData
      );
    },
    /**
     * @fn getData
     * @brief Returns the Data requested with their specific details.
     * @details Provides results in an object specified by the FILTERS.format field. Default is JSON.
     * @return (Asynchronous) Returns a jQuery deffered object. Please utilize the object's done method to obtain the data.
     * 		  (Synchronous) Returns the actual result in json format/object.
     * @version 0.1
     * @date 06/20/2014
     */
    getTags: function(
      FILTERS,
      UseAsync,
      showCallback,
      hideCallback,
      originalData
    ) {
      return _getDataFromAPI2(
        INTERFACE_TYPE.Tags,
        FILTERS,
        UseAsync,
        showCallback,
        hideCallback,
        originalData
      );
    },
    /**
     * @fn getVersion
     * @brief Returns the current version of the API
     * @details Provides results in an object specified by the FILTERS.format field. Default is JSON.
     * @return (Asynchronous) Returns a jQuery deffered object. Please utilize the object's done method to obtain the data.
     * 		  (Synchronous) Returns the actual result in json format/object.
     * @version 0.1
     * @date 06/20/2014
     */
    getVersion: function(UseAsync, showCallback, hideCallback, originalData) {
      return _getDataFromAPI2(
        INTERFACE_TYPE.Info,
        { infoType: 'Version' },
        UseAsync,
        showCallback,
        hideCallback,
        originalData
      );
    },
    /**
     * @fn getCitation
     * @brief Returns the citation to use with your application.
     * @details Provides results in an object specified by the FILTERS.format field. Default is JSON.
     * @return (Asynchronous) Returns a jQuery deffered object. Please utilize the object's done method to obtain the data.
     * 		  (Synchronous) Returns the actual result in json format/object.
     * @version 0.1
     * @date 06/20/2014
     */
    getCitation: function(UseAsync, showCallback, hideCallback, originalData) {
      return _getDataFromAPI2(
        INTERFACE_TYPE.Info,
        { infoType: 'Citation' },
        UseAsync,
        showCallback,
        hideCallback,
        originalData
      );
    },
    testLibrary: function() {
      var retCountries = _getDataFromAPI2(INTERFACE_TYPE.Countries, null, true);
      retCountries.done(function(countriesData) {}); //End Countries .done

      //Handle Errors.
      retCountries.fail(function(value) {
        console.log('Error: ', value);
      });
    },
  };
})();

//! allCountries property assignment
// This is called during the initial boot of the app. The resolved value of this is delivered as the argument to main.js@initHash
// This value is cached for two days
// NOTES
// ?? added unique app version string to localStorage keys in order to break cache when a new app version is deployed
Object.defineProperty(dhsAPI, 'allCountries', {
  value: function() {
    var exp_date = new Date(
      localStorage[
        'rest/dhs/countries-saved_at' + window.STATCOMPILER_APPLICATION_HASH
      ] || 0
    );
    var dt = exp_date.getDate();
    dt = dt + 30; // 30 day cache limit
    exp_date.setDate(dt);
    var cache_is_expired = new Date() > exp_date;
    if (
      !cache_is_expired &&
      localStorage['rest/dhs/countries' + window.STATCOMPILER_APPLICATION_HASH]
    ) {
      return $.Deferred(function(dfd) {
        var data = JSON.parse(
          localStorage[
            'rest/dhs/countries' + window.STATCOMPILER_APPLICATION_HASH
          ]
        );
        window.globalAllCountriesFullResponse = data;
        dfd.resolve(data);
      }).promise();
    } else {
      var req = this.getCountries({ f: 'json' });
      var req = $.ajax({
        url: window.DHS_API_ENDPOINT + 'countries',
      });

      req.always(function(data) {
        // delete old cache values to avoid localStorage browser limits
        for (var i in localStorage) {
          if (i.indexOf('rest/dhs/countries') !== -1) delete localStorage[i];
        }
        window.globalAllCountriesFullResponse = data;
        localStorage[
          'rest/dhs/countries' + window.STATCOMPILER_APPLICATION_HASH
        ] = JSON.stringify(data);
        localStorage[
          'rest/dhs/countries-saved_at' + window.STATCOMPILER_APPLICATION_HASH
        ] = new Date();
        return data;
      });

      return req;
    }
  },
});

Object.defineProperty(dhsAPI, 'allCountriesMap', {
  get: function() {
    var data = JSON.parse(
      localStorage['rest/dhs/countries' + window.STATCOMPILER_APPLICATION_HASH]
    );
    var mapped = {};
    data.Data.forEach(function(v, i) {
      mapped[v.DHS_CountryCode] = v.CountryName;
    });

    return mapped;
  },
});
